<template lang="pug">
  v-container.pa-2.mb-10

    v-row( justify='start' align='stretch' )
      Articulo_item( v-if='$route.params.articulo'  seleccionado :item='Novedades.novedades.find( i => i.titulo.toUpperCase() == $route.params.articulo.toUpperCase())')
      Articulo_item( v-else v-for='item, k of  [...Novedades.novedades.slice(0, limit).reverse()]' :key='k' :item='item')
      
    v-row(  justify='center' align='center' v-if='limit < Novedades.novedades.length && !$route.params.articulo').pt-10
      v-btn.white( text @click='!principal?  limit+=6 : null' :to='principal? {name: "novedades"} : null' )
        span.text-center.font-weight-black.azul--text MOSTRAR MÁS   
        v-icon.ml-2 {{principal ? "fas fa-angle-down" : "fas fa-angle-right"}}
          
          
</template>
<script>
export default {
 
  props: {
    limit: Number,
    principal: Boolean
  },
  computed: {
    Novedades() {
      return this.$contenido.Novedades  || {novedades: []}
    },

  },
  components: {
    Articulo_item: ()=>import('./Articulo_item')
  }
}
</script>